import { motion } from "framer-motion";

const IndustryIllustration = () => {
  return (
    <div className="w-full h-full relative">
      <div className="absolute inset-0 bg-gradient-to-br from-red-50 to-rose-100"></div>
      <motion.svg
        width="400"
        height="400"
        viewBox="0 0 500 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0 m-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <motion.circle
          cx="250"
          cy="250"
          r="200"
          fill="#FEF2F2"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.6 }}
        />

        {/* Left building */}
        <motion.path
          d="M200 170H120C114.477 170 110 174.477 110 180V320C110 325.523 114.477 330 120 330H200C205.523 330 210 325.523 210 320V180C210 174.477 205.523 170 200 170Z"
          fill="#FECDD3"
          stroke="#C71F2C"
          strokeWidth="8"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        />

        {/* Right building */}
        <motion.path
          d="M380 170H300C294.477 170 290 174.477 290 180V320C290 325.523 294.477 330 300 330H380C385.523 330 390 325.523 390 320V180C390 174.477 385.523 170 380 170Z"
          fill="#FECDD3"
          stroke="#C71F2C"
          strokeWidth="8"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        />

        {/* Connecting lines */}
        <motion.path
          d="M200 210H290"
          stroke="#C71F2C"
          strokeWidth="8"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        />
        <motion.path
          d="M200 250H290"
          stroke="#C71F2C"
          strokeWidth="8"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.6, delay: 0.9 }}
        />
        <motion.path
          d="M200 290H290"
          stroke="#C71F2C"
          strokeWidth="8"
          strokeLinecap="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.6, delay: 1.1 }}
        />

        {/* Left nodes */}
        <motion.circle
          cx="150"
          cy="210"
          r="15"
          fill="#C71F2C"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 300, delay: 1.3 }}
        />
        <motion.circle
          cx="150"
          cy="250"
          r="15"
          fill="#C71F2C"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 300, delay: 1.4 }}
        />
        <motion.circle
          cx="150"
          cy="290"
          r="15"
          fill="#C71F2C"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 300, delay: 1.5 }}
        />

        {/* Right nodes */}
        <motion.circle
          cx="350"
          cy="210"
          r="15"
          fill="#C71F2C"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 300, delay: 1.6 }}
        />
        <motion.circle
          cx="350"
          cy="250"
          r="15"
          fill="#C71F2C"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 300, delay: 1.7 }}
        />
        <motion.circle
          cx="350"
          cy="290"
          r="15"
          fill="#C71F2C"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 300, delay: 1.8 }}
        />
      </motion.svg>
    </div>
  );
};

export default IndustryIllustration;
